let Cities = [
  {
    url: "austin",
    fullTitle: "Austin",
    state: "Texas",
    center: [-97.8048998, 30.2988685],
    stats: {
      direction: {
        total: {
          total: [1004341, 100.0],
          l10m: [423376, 42.2],
          f10mto24m: [283294, 28.2],
          ff25mto50m: [75893, 7.6],
          g50m: [221778, 22.1],
        },
        north: {
          total: [212341, 100.0],
          l10m: [67795, 31.9],
          f10mto24m: [67485, 31.8],
          f25mto50m: [15894, 7.5],
          g50m: [61167, 28.8],
        },
        northeast: {
          total: [132822, 100.0],
          l10m: [61379, 46.2],
          f10mto24m: [44705, 33.7],
          f25mto50m: [8577, 6.5],
          g50m: [18161, 13.7],
        },
        east: {
          total: [122493, 100.0],
          l10m: [42830, 35.0],
          f10mto24m: [19239, 15.7],
          f25mto50m: [5592, 4.6],
          g50m: [54832, 44.8],
        },
        southeast: {
          total: [78157, 100.0],
          l10m: [43171, 55.2],
          f10mto24m: [19312, 24.7],
          f25mto50m: [6199, 7.9],
          g50m: [9475, 12.1],
        },
        south: {
          total: [136658, 100.0],
          l10m: [61595, 45.1],
          f10mto24m: [44540, 32.6],
          f25mto50m: [14448, 10.6],
          g50m: [16075, 11.8],
        },
        southwest: {
          total: [159676, 100.0],
          l10m: [61460, 38.5],
          f10mto24m: [39409, 24.7],
          f25mto50m: [14113, 8.8],
          g50m: [44694, 28.0],
        },
        west: {
          total: [70143, 100.0],
          l10m: [39774, 56.7],
          f10mto24m: [20363, 29.0],
          f25mto50m: [4033, 5.7],
          g50m: [5973, 8.5],
        },
        northwest: {
          total: [92051, 100.0],
          l10m: [45372, 49.3],
          f10mto24m: [28241, 30.7],
          f25mto50m: [7037, 7.6],
          g50m: [11401, 12.4],
        },
      },
      age: {
        l29: [246366, 24.5],
        f30to54: [574078, 57.2],
        o55: [183897, 18.3],
      },
      industry: [
        [1095, 0.1],
        [3008, 0.3],
        [6883, 0.7],
        [62676, 6.2],
        [57792, 5.8],
        [48959, 4.9],
        [103411, 10.3],
        [17281, 1.7],
        [29569, 2.9],
        [40309, 4.0],
        [19484, 1.9],
        [106097, 10.6],
        [6523, 0.6],
        [66003, 6.6],
        [106566, 10.6],
        [112343, 11.2],
        [16955, 1.7],
        [106409, 10.6],
        [34765, 3.5],
        [58213, 5.8],
      ],
      race: {
        white: [821947, 81.8],
        black: [95461, 9.5],
        native: [8624, 0.9],
        asian: [58738, 5.8],
        pacific: [1500, 0.1],
        mixed: [18071, 1.8],
      },
      ethnicity: {
        notLatino: [722289, 71.9],
        latino: [282052, 28.1],
      },
      sex: {
        male: [516375, 51.4],
        female: [487966, 48.6],
      },
    },
  },
  {
    url: "nyc",
    fullTitle: "New York",
    state: "New York",
    center: [-74.3612538, 40.8071888],
    stats: {
      direction: {
        total: {
          total: [9408498, 100.0],
          l10m: [5360082, 57.0],
          f10mto24m: [2453701, 26.1],
          ff25mto50m: [981475, 10.4],
          g50m: [613240, 6.5],
        },
        north: {
          total: [1196179, 100.0],
          l10m: [656815, 54.9],
          f10mto24m: [289986, 24.2],
          f25mto50m: [140330, 11.7],
          g50m: [109048, 9.1],
        },
        northeast: {
          total: [1374241, 100.0],
          l10m: [827220, 60.2],
          f10mto24m: [373855, 27.2],
          f25mto50m: [113534, 8.3],
          g50m: [59632, 4.3],
        },
        east: {
          total: [1369607, 100.0],
          l10m: [724567, 52.9],
          f10mto24m: [425290, 31.1],
          f25mto50m: [181073, 13.2],
          g50m: [38677, 2.8],
        },
        southeast: {
          total: [999918, 100.0],
          l10m: [723031, 72.3],
          f10mto24m: [215204, 21.5],
          f25mto50m: [50475, 5.0],
          g50m: [11208, 1.1],
        },
        south: {
          total: [1300524, 100.0],
          l10m: [823985, 63.4],
          f10mto24m: [278476, 21.4],
          f25mto50m: [128411, 9.9],
          g50m: [69652, 5.4],
        },
        southwest: {
          total: [1297734, 100.0],
          l10m: [640339, 49.3],
          f10mto24m: [358762, 27.6],
          f25mto50m: [149463, 11.5],
          g50m: [149170, 11.5],
        },
        west: {
          total: [1033437, 100.0],
          l10m: [505746, 48.9],
          f10mto24m: [301162, 29.1],
          f25mto50m: [145357, 14.1],
          g50m: [81172, 7.9],
        },
        northwest: {
          total: [836858, 100.0],
          l10m: [458379, 54.8],
          f10mto24m: [210966, 25.2],
          f25mto50m: [72832, 8.7],
          g50m: [94681, 11.3],
        },
      },
      age: {
        l29: [2069406, 22.0],
        f30to54: [5123077, 54.5],
        o55: [2216015, 23.6],
      },
      industry: [
        [8120, 0.1],
        [1704, 0.0],
        [43066, 0.5],
        [401722, 4.3],
        [367485, 3.9],
        [424148, 4.5],
        [953575, 10.1],
        [391005, 4.2],
        [311637, 3.3],
        [556952, 5.9],
        [220061, 2.3],
        [789345, 8.4],
        [178957, 1.9],
        [600564, 6.4],
        [909384, 9.7],
        [1589073, 16.9],
        [185844, 2.0],
        [713683, 7.6],
        [378791, 4.0],
        [383382, 4.1],
      ],
      race: {
        white: [6381647, 67.8],
        black: [1729832, 18.4],
        native: [56828, 0.6],
        asian: [1063598, 11.3],
        pacific: [14530, 0.2],
        mixed: [162063, 1.7],
      },
      ethnicity: {
        notLatino: [7598433, 80.8],
        latino: [1810065, 19.2],
      },
      sex: {
        male: [4630427, 49.2],
        female: [4778071, 50.8],
      },
    },
  },
  {
    url: "sf",
    fullTitle: "San Francisco",
    state: "California",
    center: [-122.5806555, 37.752788],
    stats: {
      direction: {
        total: {
          total: [2400290, 100.0],
          l10m: [1028267, 42.8],
          f10mto24m: [687896, 28.7],
          ff25mto50m: [327255, 13.6],
          g50m: [356872, 14.9],
        },
        north: {
          total: [274899, 100.0],
          l10m: [116601, 42.4],
          f10mto24m: [85010, 30.9],
          f25mto50m: [44570, 16.2],
          g50m: [28718, 10.4],
        },
        northeast: {
          total: [329809, 100.0],
          l10m: [89646, 27.2],
          f10mto24m: [98058, 29.7],
          f25mto50m: [56333, 17.1],
          g50m: [85772, 26.0],
        },
        east: {
          total: [332027, 100.0],
          l10m: [110234, 33.2],
          f10mto24m: [110470, 33.3],
          f25mto50m: [52939, 15.9],
          g50m: [58384, 17.6],
        },
        southeast: {
          total: [518913, 100.0],
          l10m: [145676, 28.1],
          f10mto24m: [123130, 23.7],
          f25mto50m: [92453, 17.8],
          g50m: [157654, 30.4],
        },
        south: {
          total: [267425, 100.0],
          l10m: [146448, 54.8],
          f10mto24m: [79254, 29.6],
          f25mto50m: [29280, 10.9],
          g50m: [12443, 4.7],
        },
        southwest: {
          total: [199499, 100.0],
          l10m: [143312, 71.8],
          f10mto24m: [46353, 23.2],
          f25mto50m: [9793, 4.9],
          g50m: [41, 0.0],
        },
        west: {
          total: [185451, 100.0],
          l10m: [125680, 67.8],
          f10mto24m: [47353, 25.5],
          f25mto50m: [12029, 6.5],
          g50m: [389, 0.2],
        },
        northwest: {
          total: [292267, 100.0],
          l10m: [150670, 51.6],
          f10mto24m: [98268, 33.6],
          f25mto50m: [29858, 10.2],
          g50m: [13471, 4.6],
        },
      },
      age: {
        l29: [491354, 20.5],
        f30to54: [1375938, 57.3],
        o55: [532998, 22.2],
      },
      industry: [
        [3518, 0.1],
        [1760, 0.1],
        [20996, 0.9],
        [120048, 5.0],
        [141581, 5.9],
        [85632, 3.6],
        [208380, 8.7],
        [88283, 3.7],
        [109851, 4.6],
        [105426, 4.4],
        [41730, 1.7],
        [303767, 12.7],
        [58355, 2.4],
        [155800, 6.5],
        [182478, 7.6],
        [329426, 13.7],
        [47384, 2.0],
        [229147, 9.5],
        [92172, 3.8],
        [74556, 3.1],
      ],
      race: {
        white: [1473740, 61.4],
        black: [188327, 7.8],
        native: [20545, 0.9],
        asian: [616423, 25.7],
        pacific: [16379, 0.7],
        mixed: [84876, 3.5],
      },
      ethnicity: {
        notLatino: [1902079, 79.2],
        latino: [498211, 20.8],
      },
      sex: {
        male: [1232925, 51.4],
        female: [1167365, 48.6],
      },
    },
  },
  {
    url: "chicago",
    fullTitle: "Chicago",
    state: "Illinois",
    center: [-87.8198546, 41.8171035],
    stats: {
      direction: {
        total: {
          total: [4448938, 100.0],
          l10m: [2152011, 48.4],
          f10mto24m: [1475602, 33.2],
          ff25mto50m: [583797, 13.1],
          g50m: [237528, 5.3],
        },
        north: {
          total: [695266, 100.0],
          l10m: [320416, 46.1],
          f10mto24m: [259485, 37.3],
          f25mto50m: [94597, 13.6],
          g50m: [20768, 3.0],
        },
        northeast: {
          total: [552000, 100.0],
          l10m: [269173, 48.8],
          f10mto24m: [192457, 34.9],
          f25mto50m: [82180, 14.9],
          g50m: [8190, 1.5],
        },
        east: {
          total: [591559, 100.0],
          l10m: [286515, 48.4],
          f10mto24m: [197141, 33.3],
          f25mto50m: [83353, 14.1],
          g50m: [24550, 4.2],
        },
        southeast: {
          total: [674781, 100.0],
          l10m: [323569, 48.0],
          f10mto24m: [218004, 32.3],
          f25mto50m: [96768, 14.3],
          g50m: [36440, 5.4],
        },
        south: {
          total: [586919, 100.0],
          l10m: [312502, 53.2],
          f10mto24m: [164142, 28.0],
          f25mto50m: [70284, 12.0],
          g50m: [39991, 6.8],
        },
        southwest: {
          total: [385838, 100.0],
          l10m: [197766, 51.3],
          f10mto24m: [103453, 26.8],
          f25mto50m: [32352, 8.4],
          g50m: [52267, 13.5],
        },
        west: {
          total: [418918, 100.0],
          l10m: [209077, 49.9],
          f10mto24m: [141032, 33.7],
          f25mto50m: [40468, 9.7],
          g50m: [28341, 6.8],
        },
        northwest: {
          total: [543657, 100.0],
          l10m: [232993, 42.9],
          f10mto24m: [199888, 36.8],
          f25mto50m: [83795, 15.4],
          g50m: [26981, 5.0],
        },
      },
      age: {
        l29: [1012057, 22.7],
        f30to54: [2405395, 54.1],
        o55: [1031486, 23.2],
      },
      industry: [
        [6562, 0.1],
        [1763, 0.0],
        [18445, 0.4],
        [163025, 3.7],
        [415360, 9.3],
        [240838, 5.4],
        [464950, 10.5],
        [195585, 4.4],
        [88737, 2.0],
        [223475, 5.0],
        [66400, 1.5],
        [354866, 8.0],
        [83898, 1.9],
        [337353, 7.6],
        [411356, 9.2],
        [584938, 13.1],
        [98720, 2.2],
        [390347, 8.8],
        [162816, 3.7],
        [139504, 3.1],
      ],
      race: {
        white: [3386322, 76.1],
        black: [659935, 14.8],
        native: [22817, 0.5],
        asian: [314097, 7.1],
        pacific: [4323, 0.1],
        mixed: [61444, 1.4],
      },
      ethnicity: {
        notLatino: [3665776, 82.4],
        latino: [783162, 17.6],
      },
      sex: {
        male: [2220438, 49.9],
        female: [2228500, 50.1],
      },
    },
  },
];

export default Cities;
